import Cog from 'apollo-react-icons/Cog';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { createFormEditorUrl, getFormURL, setDividers } from './utils';
import { setIsFormChangesModeEntityDisplay } from '../../actions/EntityDisplayActions';
import { FORM_EDITOR } from '../../constants/Urls';
import { useFormSelector } from '../../custom-hooks';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { useWindowDimensions } from '../../custom-hooks/useWindowDimensions';
import { FORM_KEYS } from '../../form-designer/constants/form-manager.constants';
import { DATA_CORRECTIONS_FORM_KEY } from '../../form-designer/constants/runtime.constants';
import {
  getFormInfo,
  getIsFormChangesMode,
  getIsFormChangesTableLoading,
  getNetworkStatus,
  getToken,
} from '../../form-designer/selectors/common.selectors';
import { getFormHasChanges } from '../../form-designer/selectors/form-manager.selectors';
import MenuButton from '../MenuButton';

const EditFormsButton = () => {
  const dispatch = useDispatch();
  const translateString = useTranslation();
  const history = useHistory();
  const token = useSelector(getToken);
  const isOnline = useSelector(getNetworkStatus);
  const { isMobileDevice } = useWindowDimensions();

  const stepFormInfo = useFormSelector(getFormInfo, { formKey: FORM_KEYS.STEP });
  const detailFormInfo = useFormSelector(getFormInfo, { formKey: FORM_KEYS.DETAIL });
  const isStepFormChangesMode = useFormSelector(getIsFormChangesMode, { formKey: FORM_KEYS.STEP });
  const isDetailFormChangesMode = useFormSelector(getIsFormChangesMode, {
    formKey: FORM_KEYS.DETAIL,
  });
  const stepFormHasChanges = useFormSelector(getFormHasChanges, { formKey: FORM_KEYS.STEP });
  const detailFormHasChanges = useFormSelector(getFormHasChanges, { formKey: FORM_KEYS.DETAIL });
  const isStepFormChangesTableLoading = useFormSelector(getIsFormChangesTableLoading, {
    formKey: FORM_KEYS.STEP,
  });
  const isDetailFormChangesTableLoading = useFormSelector(getIsFormChangesTableLoading, {
    formKey: FORM_KEYS.DETAIL,
  });

  const { search } = document.location;
  const detailFormKey = `${detailFormInfo.formEntityKey}_DETAIL`;
  const stepFormKey = stepFormInfo.formKey;
  const showStepFormMenuAction = stepFormKey && stepFormKey !== DATA_CORRECTIONS_FORM_KEY;

  const getDesignFormItem = (text, formKey) => ({
    group: 'designForm',
    text: translateString(text),
    onClick: () => window.open(getFormURL(formKey, token), '_blank'),
  });

  const menuItems = [getDesignFormItem('Design Detail Form', detailFormKey)];

  if (showStepFormMenuAction) {
    menuItems.unshift(getDesignFormItem('Design Step Form', stepFormKey));
  }

  const getEditFormItem = (text, formKey) => ({
    group: 'editForm',
    text: translateString(text),
    onClick: () => history.push(`${FORM_EDITOR}${createFormEditorUrl(search, formKey)}`),
  });

  if (showStepFormMenuAction) {
    menuItems.push(getEditFormItem('Edit Step Form', stepFormKey));
  }

  menuItems.push(getEditFormItem('Edit Detail Form', detailFormKey));

  if (!isMobileDevice) {
    if (showStepFormMenuAction) {
      menuItems.push({
        group: 'formChanges',
        text: translateString(`${isStepFormChangesMode ? 'Hide' : 'Show'} Step Form Delta Changes`),
        disabled: !stepFormHasChanges || isStepFormChangesTableLoading,
        onClick: () =>
          dispatch(setIsFormChangesModeEntityDisplay(!isStepFormChangesMode, FORM_KEYS.STEP)),
      });
    }

    menuItems.push({
      group: 'formChanges',
      text: translateString(
        `${isDetailFormChangesMode ? 'Hide' : 'Show'} Detail Form Delta Changes`
      ),
      disabled: !detailFormHasChanges || isDetailFormChangesTableLoading,
      onClick: () =>
        dispatch(setIsFormChangesModeEntityDisplay(!isDetailFormChangesMode, FORM_KEYS.DETAIL)),
    });
  }

  setDividers(menuItems);

  return (
    <MenuButton
      icon={Cog}
      buttonText={translateString('Edit Forms')}
      menuItems={menuItems}
      disabled={!isOnline}
    />
  );
};

export default EditFormsButton;
